import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TenantInstructorSettings } from '../../../shared/services/tenant.service';

@Component({
  selector: 'black-instructor-section',
  templateUrl: './instructor-section.component.html',
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class InstructorSectionComponent {
  @Input() instructor?: TenantInstructorSettings;
  @Input() tenantName?: string;
  @Input() theme: 'modern' | 'warm' | 'bold' = 'modern';

  get name(): string {
    return this.instructor?.name || this.tenantName || 'Lead Instructor';
  }

  get title(): string {
    return this.instructor?.title || 'Senior Educator & Course Lead';
  }

  get bio(): string {
    return (
      this.instructor?.bio ||
      'Dedicated to delivering high-impact, interactive lessons with comprehensive syllabus coverage, structured revision notes, and exam paper discussions.'
    );
  }

  get avatarUrl(): string {
    return (
      this.instructor?.avatarUrl ||
      'assets/images/default-avatar.png'
    );
  }

  get experienceYears(): number | undefined {
    return this.instructor?.experienceYears;
  }

  get highlights(): string[] {
    if (this.instructor?.highlights && this.instructor.highlights.length > 0) {
      return this.instructor.highlights;
    }
    return [
      'Comprehensive Theory & Concept Focus',
      'Step-by-step Past Paper Discussions',
      'Continuous Assessment & Progress Tracking',
    ];
  }
}
